<!-- your-component.component.html -->
<div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
<mat-card>
  <mat-card-title>
      <h2>Employee Details</h2>
  </mat-card-title>
  <mat-card-content>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 for">

        <h4>Employee Name : <b>{{userLeaveDetails?.name}}</b></h4>
        
       
  
          <h4> Applied Days: <b>{{userLeaveDetails?.leave_days}}</b></h4>
          
          </div>

          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 for">

    <h4> From : <b>{{userLeaveDetails?.leave_from | date: 'dd-MMM-yyyy'}}</b>  To : <b>{{userLeaveDetails?.leave_to | date: 'dd-MMM-yyyy'}}</b></h4>
    <h4>Leave Type : <b>{{userLeaveDetails?.leave_type}}</b></h4>
    </div>
    <h4>Reporting To : <b>{{userLeaveDetails?.reporting_name}}</b></h4>
    <h4>Avaiable Leaves : <b>{{userLeaveBalance}}</b></h4>
    </div>


    
  </mat-card-content>
</mat-card>
</div>
<br>
<div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

<mat-card>
  <mat-card-title>
      <h2>Employee Leave Updates</h2>
  </mat-card-title>
  <mat-card-content>
    
<div class="container">
  
    <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="isShowAlert">
        <b> Leave Updated successfully.</b>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="isShowErrorAlert">
      <b>Something went wrong please try again</b>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
  </div>
    
    <form [formGroup]="leaveStatus" #myForm="ngForm" (ngSubmit)="leaveStatusSubmit()">
      <mat-form-field [formGroup]="leaveStatus">
        <mat-label>Reason</mat-label>
        <textarea matInput formControlName="leave_status_reason" ></textarea>
        <mat-error *ngIf="leaveStatusValidate?.leave_status_reason?.errors?.required">This field is required.</mat-error>
      </mat-form-field>
  
      <mat-form-field [formGroup]="leaveStatus">
        <mat-label>Status</mat-label>
        <mat-select formControlName="leave_status" >
          <mat-option value="2">Approve</mat-option>
          <mat-option value="3">Reject</mat-option>
          <mat-option value="4">Cancel</mat-option>
        </mat-select>
        <mat-error *ngIf="leaveStatusValidate?.leave_status?.errors?.required">This field is required.</mat-error>
      </mat-form-field>
  
      <div class="footer-block text-center">
        <div class="button-group">
          <button type="submit" mat-raised-button class="btn-int-blue">Submit</button>
        </div>
      </div>
    </form>
  </div>
</mat-card-content>
</mat-card>
  </div>